<template>
  <div class="bg-white">
    <div class="container">
      <b-navbar toggleable="lg" type="light">
        <b-navbar-brand class="col col-4 col-sm-3 col-md-3 col-lg-2 common-padding-left-0" href="/">
          <h1 class="common-line-height-3-5 font-35 color-purple ">银典科技</h1> <!--<img class="col col-12 common-padding-left-0" :src="require('images/kf_logo.jpg')">--></b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto menu">
            <router-link tag="span" active-class="menu-active" exact class="common-padding-left common-padding-right common-padding-top-0-8 common-padding-bottom-0-8" :to="{path:'/'}">支付介绍
            </router-link>
            <div class="down-menu-div">
              <router-link tag="div" active-class="menu-active" class="menu-c common-padding-left common-padding-right common-padding-top-0-8 common-padding-bottom-0-8" :to="{path:'/product'}">实战分析</router-link>
              <div class="down-menu-content-div font-12 bg-white">
                <router-link tag="div" active-class="menu-active" class="common-padding-left common-padding-right common-padding-top-0-5 common-padding-bottom-0-5" :to="{path:'/product/xls'}">新零售平台</router-link>
               <!-- <router-link tag="div" active-class="menu-active" class="common-padding-left common-padding-right common-padding-top-0-5 common-padding-bottom-0-5 font-10" :to="{path:'/product/gt'}">高铁运营平台</router-link>-->
                <router-link tag="div" active-class="menu-active" class="common-padding-left common-padding-right common-padding-top-0-5 common-padding-bottom-0-5" :to="{path:'/product/jmls'}">加盟连锁店</router-link>
                <router-link tag="div" active-class="menu-active" class="common-padding-left common-padding-right common-padding-top-0-5 common-padding-bottom-0-5" :to="{path:'/product/sjds'}">社交电商</router-link>
                <router-link tag="div" active-class="menu-active" class="common-padding-left common-padding-right common-padding-top-0-5 common-padding-bottom-0-5" :to="{path:'/product/fl'}">返利平台</router-link>
                <router-link tag="div" active-class="menu-active" class="common-padding-left common-padding-right common-padding-top-0-5 common-padding-bottom-0-5" :to="{path:'/product/cysc'}">创意商城</router-link>
              </div>
            </div>
            <router-link tag="span" active-class="menu-active" class="common-padding-left common-padding-right common-padding-top-0-8 common-padding-bottom-0-8" :to="{path:'/interface'}">
              支付接口
            </router-link>
            <router-link tag="span" active-class="menu-active" class="common-padding-left common-padding-right common-padding-top-0-8 common-padding-bottom-0-8" :to="{path:'/introduce'}">
              关于我们
            </router-link>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommHeader',
  data () {
    return {
      activeIndex: 1
    }
  },
  methods: {
    activeMenu (index) {
      this.activeIndex = index
      console.log('this.activeIndex:' + this.activeIndex)
    }
  }
}
</script>
<style>
  .navbar-nav span,.navbar-nav div{
    cursor: pointer;
  }
  @media (min-width: 992px) {
    .down-menu-div{
      position: relative;
      display: inline-block;
      z-index: 999;
    }
    .down-menu-content-div{
      position: absolute;
      display: none;
    }
    .down-menu-div:hover .down-menu-content-div {
      display: block;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/CommHeader.vue